import { useState, useEffect } from "react";
import PageHeader from "@/components/PageHeader";
import { getQuotes, getContacts } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function Admin() {
  const [tab, setTab] = useState("quotes");
  const [quotes, setQuotes] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([getQuotes(), getContacts()])
      .then(([q, c]) => { setQuotes(q); setContacts(c); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const rows = tab === "quotes" ? quotes : contacts;

  return (
    <div data-testid="admin-page">
      <PageHeader overline="Admin" title="Submissions dashboard" subtitle="Quote requests and contact enquiries received through the website." />
      <section className="mx-auto max-w-[1400px] px-5 lg:px-10 py-10">
        <div className="flex gap-2 mb-6">
          {["quotes", "contacts"].map((t) => (
            <button key={t} onClick={() => setTab(t)} data-testid={`admin-tab-${t}`} className={`rounded-full px-5 py-2 text-sm font-medium border capitalize transition-colors ${tab === t ? "bg-navy text-white border-navy" : "border-border hover:bg-secondary"}`}>
              {t} ({t === "quotes" ? quotes.length : contacts.length})
            </button>
          ))}
        </div>
        {loading ? (
          <div className="py-20 grid place-items-center"><Loader2 className="animate-spin text-royal" /></div>
        ) : rows.length === 0 ? (
          <p className="py-20 text-center text-muted-foreground" data-testid="admin-empty">No {tab} yet.</p>
        ) : (
          <div className="space-y-3" data-testid="admin-list">
            {rows.map((r) => (
              <div key={r.id} className="rounded-2xl border border-border bg-card p-5">
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <h3 className="font-heading font-bold text-foreground">{r.name} {r.company && <span className="text-muted-foreground font-normal">· {r.company}</span>}</h3>
                  <span className="font-mono-accent text-xs text-muted-foreground">{new Date(r.created_at).toLocaleString()}</span>
                </div>
                <div className="mt-2 text-sm text-muted-foreground flex flex-wrap gap-x-5 gap-y-1">
                  <span>{r.email}</span>{r.phone && <span>{r.phone}</span>}{r.city && <span>{r.city}</span>}
                  {r.product && <span className="text-royal">{r.product}</span>}{r.quantity && <span>Qty: {r.quantity}</span>}
                  {r.subject && <span>Subject: {r.subject}</span>}
                </div>
                {r.message && <p className="mt-2 text-sm text-foreground whitespace-pre-line">{r.message}</p>}
                {r.artwork_name && <p className="mt-1 text-xs text-muted-foreground">Artwork: {r.artwork_name}</p>}
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
